export default __webpack_public_path__ + "static/media/checkbox-inactive.daae7e69.svg";